import type { SxProps, Theme } from '@mui/material/styles';

type SearchFieldStyles = {
  label: SxProps<Theme>;
  clearButton: SxProps<Theme>;
  clearButtonText: SxProps<Theme>;
  arrowIcon: (open: boolean) => SxProps<Theme>;
  inputProps: (open: boolean) => SxProps<Theme>;
};

export const styles: SearchFieldStyles = {
  label: {
    m: 1,
  },

  clearButton: {
    cursor: 'pointer',
    color: 'action.active',
    display: 'flex',
    alignItems: 'center',
    mr: 1,
    '&:hover': {
      color: 'primary.main',
    },
  },

  clearButtonText: {
    fontSize: '16px',
    fontWeight: 'fontWeightBold',
    lineHeight: 1,
  },

  arrowIcon: open => ({
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.3s',
  }),

  inputProps: open => ({
    cursor: open ? 'text' : 'pointer',
    '& input': {
      cursor: open ? 'text' : 'pointer',
    },
    ...(open && {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    }),
  }),
};
